import { render, staticRenderFns } from "./pedidos.vue?vue&type=template&id=598f09c8&scoped=true&"
import script from "./pedidos.vue?vue&type=script&lang=ts&"
export * from "./pedidos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598f09c8",
  null
  
)

export default component.exports